import { Phone } from "lucide-react";
import { motion } from "framer-motion";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { CONTACT, waLink } from "@/data/site";

export default function FloatingCTAs() {
  return (
    <motion.div
      data-testid="floating-ctas"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.4, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-[4.75rem] right-4 z-40 flex flex-col gap-3 md:bottom-6 md:right-6"
    >
      <a
        href={CONTACT.phoneTel}
        data-testid="floating-call-button"
        aria-label="Call Belong Saloon and Spa"
        className="glow-pulse flex items-center justify-center rounded-full bg-gold text-stone-950 shadow-xl shadow-gold/30 transition-transform duration-300 hover:scale-110 active:scale-95"
        style={{ height: 52, width: 52 }}
      >
        <Phone size={21} />
      </a>
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="WhatsApp Belong Saloon and Spa"
        className="flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl shadow-emerald-600/30 transition-transform duration-300 hover:scale-110 active:scale-95"
        style={{ height: 52, width: 52 }}
      >
        <WhatsAppIcon size={24} />
      </a>
    </motion.div>
  );
}
